var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9976 17.4411C42.1126 17.4411 48.691 24.3687 48.691 32.9144C48.691 36.1708 47.7358 39.1923 46.1043 41.685L53.6035 49.5824L49.8254 53.561L42.3261 45.6638C39.9591 47.3818 37.0899 48.3878 33.9976 48.3878C25.8827 48.3878 19.3042 41.4601 19.3042 32.9144C19.3042 24.3687 25.8827 17.4411 33.9976 17.4411ZM33.9976 23.0677C28.8336 23.0677 24.6473 27.4762 24.6473 32.9144C24.6473 38.3526 28.8336 42.7611 33.9976 42.7611C39.1617 42.7611 43.348 38.3526 43.348 32.9144C43.348 27.4762 39.1617 23.0677 33.9976 23.0677ZM16.6833 31.5076C16.6498 31.9719 16.6327 32.4411 16.6327 32.9144C16.6327 34.3669 16.7935 35.7799 17.0974 37.1346L0.603516 37.1344V31.5077L16.6833 31.5076ZM11.2896 0.561035V28.6944H3.27504V0.561035H11.2896ZM21.9757 11.8144L21.9754 19.719C19.6048 22.1148 17.8785 25.2122 17.0974 28.6942L13.9612 28.6944V11.8144H21.9757ZM32.6618 6.18771L32.6618 14.681C29.7258 14.9162 26.9939 15.9203 24.6472 17.5025L24.6473 6.18771H32.6618ZM43.348 9.00105L43.348 17.5025C41.0014 15.9203 38.2695 14.9163 35.3335 14.681L35.3334 9.00105H43.348Z",
    fill: "#A2A5F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameReview);
export default __webpack_public_path__ + "static/media/Game-review.045e8aa3b65226f6ab0495ced11663ef.svg";
export { ForwardRef as ReactComponent };